import facilityTrackingList from './list.vue'

let a = Object.assign({  facilityTrackingList},)
export default a
